/**
 * @Description:  格式化时间相关
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/20 下午5:37
 */
// 调用方法如：this.$dateFormat.formatDate(new Date(), 'yyyy-MM-dd')

export default class dateFormat {
  /**
   * @Description: 格式化时间
   * @param: data: 国际标准时间，fmt: 格式（yyyy-MM-dd）
   * @Author: ZhangBin
   * @Date
   */
  static formatDate = (date, fmt) => {
    let o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
        "H+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
    {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt))
      {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  };
  /**
   * @Description: 获取当前时间的前几天
   * @param:  val: 需要获取的前几天
   * @Author: ZhangBin
   * @Date
   */
  static getPreDate = (val) => {
    let date = new Date();
    let [year, mon, day] = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
    ];
    let currentDate = year + '-' + mon + '-' + day;
    if(day <= val){
      if(mon>1) {
        mon=mon-1;
      }
      else {
        year = year-1;
        mon = 12;
      }
    }
    date.setDate(date.getDate()-val);
    year = date.getFullYear();
    mon=date.getMonth()+1;
    day=date.getDate();
    let preDate = year + "-" + (mon < 10?('0' + mon) : mon) + "-" + (day < 10?('0' + day) : day);

    return {
      c: currentDate,
      p: preDate
    }
  };
  /**
   * @Description:  datetimepicker 时间快捷选项
   * @param:
   * @Author: ZhangBin
   * @Date 2019-04-10 14:07
   */
  static datePickerOptions = () => {
    return {
      shortcuts: [{
        text: '2小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 2);
          picker.$emit('pick', date);
        }
      }, {
        text: '4小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 4);
          picker.$emit('pick', date);
        }
      }, {
        text: '6小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 6);
          picker.$emit('pick', date);
        }
      }, {
        text: '12小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 12);
          picker.$emit('pick', date);
        }
      }, {
        text: '24小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '48小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 48);
          picker.$emit('pick', date);
        }
      }, {
        text: '72小时',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 72);
          picker.$emit('pick', date);
        }
      }, {
        text: '长期',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 100000);
          picker.$emit('pick', date);
        }
      }]
    }
  };
  /**
   * @Description:  将毫秒转换为天、小时、分钟、秒
   * @param:
   * @Author: ZhangBin
   * @Date 2019-10-14 15:07
   */
  static formatMillisecond = (ms) => {
    try {
      let days = ms / 1000 / 60 / 60 / 24, daysRound = Math.floor(days);
      let hours = ms / 1000 / 60 / 60 - (24 * daysRound), hoursRound = Math.floor(hours);
      let minutes = ms / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound), minutesRound = Math.floor(minutes);
      let seconds = ms / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
      return {
        day: daysRound,
        hours: hoursRound,
        minutes: minutesRound,
        seconds: seconds,
      }
    }
     catch (e) {
      throw new Error('The parameter is invalid!')
    }
  };
  /**
   * @Description:  禁用el-datetimepicker 当前时间之前的时分秒
   * @param:
   * @Author: ZhangBin
   * @Date 2019-11-14 10:57
   */
  static disabledTimeBeforeNow = () => {
    let H = new Date().getHours(),
      M = new Date().getMinutes(),
      S = new Date().getSeconds();
    if(H < 10) H = '0' + H;
    if(M < 10) M = '0' + M;
    if(S < 10) S = '0' + S;

    return {selectableRange: [H +':' + M + ':' + S + ' - 23:59:59']}
  }
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js